import { AbstractControl, ValidationErrors } from '@angular/forms';

export function nonEmptyHtmlValidator(control: AbstractControl): ValidationErrors | null {
  const text = (control.value ?? '').replace(/<[^>]*>/g, '').trim();
  return text.length > 0 ? null : { required: true };
}
